<template>
  <div>
    <div id="main-section">
      <div class="col-md-12">
        <img src="@/assets/images/logo/enviame.svg" alt="login" class="mx-auto mt-2" width="200">
      </div>
      <hr>

      <div class="margin-containerr">
        <div id="main-section" class="row text-center">
          <div class="col-md-5 my-auto border-right">
            <div id="img-section">
              <svg class="mx-auto" width="400" height="400" viewBox="0 0 330 330" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M299.2 179.919L283.319 151.25L275.619 137.5C273.375 133.36 270.06 129.899 266.02 127.48C261.981 125.061 257.365 123.773 252.656 123.75H200.681C198.522 127.521 195.758 130.912 192.5 133.787C190.566 135.519 188.471 137.061 186.244 138.394L184.8 139.15C182.949 140.195 181.018 141.092 179.025 141.831C174.533 143.487 169.787 144.347 165 144.375C154.06 144.375 143.568 140.029 135.832 132.293C128.096 124.557 123.75 114.065 123.75 103.125C123.757 100.823 123.941 98.5242 124.3 96.25H55C47.7065 96.25 40.7118 99.1473 35.5546 104.305C30.3973 109.462 27.5 116.457 27.5 123.75V226.875C27.5 234.168 30.3973 241.163 35.5546 246.32C40.7118 251.478 47.7065 254.375 55 254.375H55.6875C57.2654 262.146 61.4813 269.132 67.6207 274.15C73.7602 279.168 81.4457 281.909 89.375 281.909C97.3043 281.909 104.99 279.168 111.129 274.15C117.269 269.132 121.485 262.146 123.062 254.375H206.938C208.515 262.146 212.731 269.132 218.871 274.15C225.01 279.168 232.696 281.909 240.625 281.909C248.554 281.909 256.24 279.168 262.379 274.15C268.519 269.132 272.735 262.146 274.313 254.375H276.238C283.203 254.375 289.883 251.608 294.808 246.683C299.733 241.758 302.5 235.078 302.5 228.112V192.5C302.5 188.092 301.363 183.759 299.2 179.919ZM275 165L282.562 178.75L286.413 185.625H240.625C238.802 185.625 237.053 184.901 235.764 183.611C234.474 182.322 233.75 180.573 233.75 178.75V171.875C233.75 170.052 234.474 168.303 235.764 167.014C237.053 165.724 238.802 165 240.625 165H275ZM89.375 268.125C84.5717 268.11 79.9241 266.42 76.2341 263.345C72.5441 260.27 70.0431 256.003 69.1625 251.281C68.8861 250.04 68.7477 248.772 68.75 247.5C68.75 242.03 70.923 236.784 74.7909 232.916C78.6589 229.048 83.9049 226.875 89.375 226.875C94.8451 226.875 100.091 229.048 103.959 232.916C107.827 236.784 110 242.03 110 247.5C110.002 248.772 109.864 250.04 109.587 251.281C108.707 256.003 106.206 260.27 102.516 263.345C98.8259 266.42 94.1783 268.11 89.375 268.125ZM123.062 240.625V240.006C122.658 238.155 122.107 236.338 121.412 234.575L120.312 232.375C119.799 231.232 119.202 230.129 118.525 229.075L116.875 226.875C116.2 225.957 115.465 225.084 114.675 224.262C114.063 223.547 113.396 222.881 112.681 222.269L110 220C109.248 219.433 108.468 218.905 107.662 218.419L104.5 216.7L102.094 215.6C100.815 215.106 99.5059 214.692 98.175 214.362L96.25 213.812C91.9441 212.895 87.4934 212.895 83.1875 213.812L81.0563 214.362C79.7253 214.692 78.4165 215.106 77.1375 215.6L74.7313 216.7L71.5687 218.419C70.599 218.89 69.6578 219.418 68.75 220L66.1375 222.2C65.4224 222.812 64.7558 223.479 64.1437 224.194C63.3281 225.035 62.5701 225.931 61.875 226.875L60.225 229.144C59.5481 230.198 58.9506 231.301 58.4375 232.444C58.4375 233.2 57.6813 233.887 57.3375 234.644C56.6433 236.407 56.0915 238.223 55.6875 240.075V240.694H55C51.3533 240.694 47.8559 239.245 45.2773 236.666C42.6987 234.088 41.25 230.59 41.25 226.944V123.75C41.25 120.103 42.6987 116.606 45.2773 114.027C47.8559 111.449 51.3533 110 55 110H110.619C112.113 122.353 117.819 133.813 126.775 142.45C136.996 152.444 150.705 158.066 165 158.125C169.636 158.109 174.253 157.532 178.75 156.406V185.625H75.625C73.8016 185.625 72.053 186.349 70.7636 187.639C69.4743 188.928 68.75 190.677 68.75 192.5C68.75 194.323 69.4743 196.072 70.7636 197.361C72.053 198.651 73.8016 199.375 75.625 199.375H178.75V240.625H123.062ZM240.625 268.125C235.822 268.11 231.174 266.42 227.484 263.345C223.794 260.27 221.293 256.003 220.413 251.281C220.136 250.04 219.998 248.772 220 247.5C220 242.03 222.173 236.784 226.041 232.916C229.909 229.048 235.155 226.875 240.625 226.875C246.095 226.875 251.341 229.048 255.209 232.916C259.077 236.784 261.25 242.03 261.25 247.5C261.252 248.772 261.114 250.04 260.837 251.281C259.957 256.003 257.456 260.27 253.766 263.345C250.076 266.42 245.428 268.11 240.625 268.125ZM288.75 228.112C288.732 231.425 287.408 234.598 285.065 236.94C282.723 239.283 279.55 240.607 276.238 240.625H274.313V240.006C273.908 238.155 273.357 236.338 272.663 234.575L271.562 232.375C271.049 231.232 270.452 230.129 269.775 229.075L268.125 226.875C267.45 225.957 266.715 225.084 265.925 224.262C265.313 223.547 264.646 222.881 263.931 222.269L261.25 220C260.498 219.433 259.718 218.905 258.913 218.419L255.75 216.7L253.344 215.6C252.065 215.106 250.756 214.692 249.425 214.362L247.5 213.812C243.194 212.895 238.743 212.895 234.437 213.812L232.306 214.362C230.975 214.692 229.666 215.106 228.388 215.6L225.981 216.7L222.819 218.419C221.849 218.89 220.908 219.418 220 220L217.388 222.2C216.672 222.812 216.006 223.479 215.394 224.194C214.578 225.035 213.82 225.931 213.125 226.875L211.475 229.144C210.798 230.198 210.201 231.301 209.688 232.444L208.587 234.644C207.893 236.407 207.342 238.223 206.938 240.075V240.694H192.5V150.7C195.784 148.741 198.85 146.436 201.644 143.825C203.919 141.838 206.013 139.652 207.9 137.294H252.656C254.889 137.298 257.08 137.899 259.003 139.035C260.925 140.172 262.508 141.802 263.587 143.756L267.644 151.25H240.625C235.155 151.25 229.909 153.423 226.041 157.291C222.173 161.159 220 166.405 220 171.875V178.75C220 184.22 222.173 189.466 226.041 193.334C229.909 197.202 235.155 199.375 240.625 199.375H288.75V228.112Z" fill="#044389"/>
                <path d="M134.721 57.8099C143.684 51.8214 154.221 48.625 165 48.625C179.454 48.625 193.317 54.3669 203.537 64.5877C213.758 74.8084 219.5 88.6707 219.5 103.125C219.5 113.904 216.304 124.441 210.315 133.404C204.327 142.366 195.815 149.351 185.856 153.476C175.898 157.601 164.94 158.681 154.368 156.578C143.796 154.475 134.085 149.284 126.463 141.662C118.841 134.04 113.65 124.329 111.547 113.757C109.444 103.185 110.524 92.2273 114.649 82.2687C118.774 72.3102 125.759 63.7984 134.721 57.8099Z" fill="#F18805" stroke="#F18805"/>
                <path d="M174.694 103.125L183.631 94.2563C184.272 93.6153 184.781 92.8543 185.127 92.0168C185.474 91.1792 185.653 90.2816 185.653 89.3751C185.653 88.4685 185.474 87.5709 185.127 86.7333C184.781 85.8958 184.272 85.1348 183.631 84.4938C182.99 83.8528 182.229 83.3443 181.392 82.9974C180.554 82.6505 179.656 82.4719 178.75 82.4719C177.843 82.4719 176.946 82.6505 176.108 82.9974C175.271 83.3443 174.51 83.8528 173.869 84.4938L165 93.4313L156.131 84.4938C154.836 83.1992 153.081 82.4719 151.25 82.4719C149.419 82.4719 147.663 83.1992 146.369 84.4938C145.074 85.7884 144.347 87.5442 144.347 89.3751C144.347 91.2059 145.074 92.9617 146.369 94.2563L155.306 103.125L146.369 111.994C145.074 113.288 144.347 115.044 144.347 116.875C144.347 118.706 145.074 120.462 146.369 121.756C147.663 123.051 149.419 123.778 151.25 123.778C153.081 123.778 154.836 123.051 156.131 121.756L165 112.819L173.869 121.756C174.508 122.401 175.268 122.912 176.106 123.261C176.944 123.61 177.842 123.79 178.75 123.79C179.657 123.79 180.556 123.61 181.394 123.261C182.232 122.912 182.992 122.401 183.631 121.756C184.275 121.117 184.787 120.357 185.136 119.519C185.485 118.681 185.665 117.783 185.665 116.875C185.665 115.967 185.485 115.069 185.136 114.231C184.787 113.393 184.275 112.633 183.631 111.994L174.694 103.125Z" fill="#ECE8E8"/>
              </svg>

              <!--Información del retiro  -->
              <div class="col-md-12 pickup-font text-center" v-if="pickup">
                <!-- Identifier -->
                <div class="mb-2 col-sm-7 col-md-7 mx-auto text-left">
                  <span> <b> <feather-icon icon="HashIcon" size="1x"/> </b> {{ pickup.identifier || '--' }}</span>
                </div>

                <!-- Fecha de retiro -->
                <div class="mb-2 col-sm-7 col-md-7 mx-auto text-left">
                  <span> <b> <feather-icon icon="CalendarIcon" size="1x"/> </b> {{ pickup.format_pickup_date || '--' }}</span>
                </div>

                <!-- Rango horario -->
                <div class="mb-2 col-sm-7 col-md-7 mx-auto text-left">
                  <span> <b> <feather-icon icon="ClockIcon" size="1x"/> </b> {{ pickup.range_time || '--' }}</span>
                </div>

                <!-- Carrier -->
                <div class="mb-2 col-sm-7 col-md-7 mx-auto text-left">
                  <span> <b> <feather-icon icon="TruckIcon" size="1x"/> </b> {{ pickup.carrier.name || '--' }}</span>
                </div>

                <!-- Dirección -->
                <div class="mb-2 col-sm-7 col-md-7 mx-auto text-left">
                  <span> <b> <feather-icon icon="MapPinIcon" size="1x"/> </b> {{ pickup.address.full_address || '--' }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showCountDown" class="col-md-7 margin-container">
            <div id="form-section">
              <!-- Formulario -->
              <b-form class="col-sm-7 col-md-6 mx-auto">
                <h3 class="mb-5 title-font text-primary">Cancelar retiro</h3>
                <b-form-group class="col-md-12">
                  <label for="select-reason" class="form-font">Motivo</label>
                  <b-form-select class="col-md-12" id="select-reason" v-model="form" :options="options"></b-form-select>
                </b-form-group>

                <b-button @click="onSubmit" :disabled="disabled.cancelButton"  variant="warning" class="mt-2">
                  {{$t('Confirmar')}}
                  <feather-icon v-if="!loading.cancelButton" icon="DownloadIcon"/>
                  <i v-else :class="['fa', 'fa-spinner', 'fa-spin']"/>
                </b-button>
              </b-form>

              <!-- Contador -->
              <div id="timer" class="col-sm-12 col-md-12 col-lg-8 mx-auto mt-5">
                <h4>Tiempo restante para cancelar el retiro</h4>
                <b-card border-variant="warning" class="text-warning p-0 col-md-12 mt-2 custom-rounded-card">

                  <div class="container--countdown">
                    <div>
                      <span class="number">{{ time.days }}</span>
                      <span class="metric">DIAS</span>
                    </div>
                    <div>
                      <span class="dot">:</span>
                    </div>
                    <div>
                      <span class="number">{{ time.hours }}</span>
                      <span class="metric">HORAS</span>
                    </div>
                    <div>
                      <span class="dot">:</span>
                    </div>
                    <div>
                      <span class="number">{{ time.minutes }}</span>
                      <span class="metric">MINUTOS</span>
                    </div>
                    <div>
                      <span class="dot">:</span>
                    </div>
                    <div>
                      <span class="number">{{ time.seconds }}</span>
                      <span class="metric">SEGUNDOS</span>
                    </div>
                  </div>

                </b-card>
                <span class="text-warning pickup-font">Fecha limite para cancelar {{ pickup.format_max_cancelation_date }} </span>
              </div>
            </div>
          </div>

          <!-- Mensajes -->
          <div v-if="!showCountDown" class="col-md-7 margin-message">
            <h4 class="message-font"> {{ panelMessage }} </h4>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import duration from 'dayjs/plugin/duration'
import PublicPickupsService from './public-pickups.service'

dayjs.extend(utc)
dayjs.extend(duration)

export default {
  data () {
    return {
      fields: [],
      form: null,
      pickup: null,
      showCountDown: false,
      panelMessage: '',
      disabled: {
        cancelButton: true
      },
      loading: {
        cancelButton: false
      },
      options: [
        { text: 'Seleccione el motivo...', value: null, disabled: true },
        { text: 'No es necesario el retiro', value: 'not_necessary' },
        { text: 'El retiro posee datos incorrectos', value: 'incorrect_data' }
      ],
      time: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      PublicPickupsService: new PublicPickupsService(this)
    }
  },
  mounted () {
    this.initializeData()
  },
  watch: {
    form () {
      if (this.form) this.disabled.cancelButton = false
      else this.disabled.cancelButton = true
    }
  },
  methods: {
    initializeData () {
      // Activa el spinner de la plataforma
      this.PublicPickupsService.callService('getPickupsCancelData', null, { uuid: this.$route.params.uuid }, { fullResponseError: true })
        .then(resp => {
          // Datos del retiro a mostrar en pantalla
          this.pickup = resp.data
          this.pickup.format_pickup_date = dayjs(resp.data.pickup_date).format('DD/MM/YYYY')
          this.pickup.format_max_cancelation_date = dayjs(resp.data.max_cancelation_date).format('DD/MM/YYYY')

          switch (resp.data.cancelation_status) {
          case 'available':
            this.showCountDown = true
            // Ejeción del countdown
            this.updateCountdown()
            this.intervalId = setInterval(this.updateCountdown.bind(this), 1000)
            break
          case 'canceled':
            this.showCountDown = false
            this.panelMessage = 'El retiro ya fue cancelado.'
            break
          case 'expired':
            this.showCountDown = false
            this.panelMessage = 'Lo sentimos, ya no es posible cancelar el retiro.'
            break

          default:
            this.showCountDown = false
            this.panelMessage = 'Ha ocurrido un error inesperado.'
            break
          }
        })
        .catch(error => {
          this.showCountDown = false
          this.panelMessage = error.data
        })
        .finally(() => {
          // Desactiva el spinner de la plataforma
        })
    },
    /**
     * Función que genera en conteo de los dias restantes para la cancelación
     */
    updateCountdown() {
      const maxDate = dayjs(this.pickup.max_cancelation_date, 'YYYY-MM-DD HH:mm:ss').utc(true)
      const currentDate = dayjs.utc()
      const duration = dayjs.duration(maxDate.diff(currentDate))

      if (duration < 0) {
        clearInterval(this.intervalId)
        this.showCountDown = false
        this.panelMessage = 'Lo sentimos, ya no es posible cancelar el retiro.'
      } else {
        this.showCountDown = true
        this.time.days = String(Math.floor(duration.asDays())).padStart(2, '0')
        this.time.hours = String(duration.hours()).padStart(2, '0')
        this.time.minutes = String(duration.minutes()).padStart(2, '0')
        this.time.seconds = String(duration.seconds()).padStart(2, '0')
      }
    },
    onSubmit (event) {
      event.preventDefault()
      this.loading.cancelButton = true
      this.disabled.cancelButton = true
      const queryParams = {
        reason_code: this.form
      }
      this.PublicPickupsService.callService('cancelPickup', queryParams, { uuid: this.$route.params.uuid })
        .then(resp => {
          clearInterval(this.intervalId)
          this.showCountDown = false
          this.panelMessage = 'Muchas gracias, el retiro ha sido cancelado con éxito.'
        })
        .catch(error => {
          this.$alert('Ha ocurrido un error inesperado.')
        })
        .finally(() => {
          this.loading.cancelButton = false
          this.disabled.cancelButton = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.time-font {
  font-size: 30px;
  font-weight: bold;
}
.title-font{
  font-size: 40px;
}
.message-font{
  font-size: 30px;
}
.form-font {
  font-size: 20px;
  font-weight: bold;
}
.pickup-font {
  font-size: 20px;
}

.margin-container {
  margin-top: 5%;
}
.margin-message {
  margin-top: 15%;
}
.border-right {
  border-right: 1px solid;
}
.time-block {
  display: inline-block;
  margin-right: 10px;
}

.custom-rounded-card {
  border-radius: 50px;
}

// Clases Contador

.container--countdown{
  display:flex;
  width: 100%;
  justify-content: space-around;
  align-content: center
}

.number{
  display:block;
  font-size: 60px;
}

.metric{
  font-size: 15px;
}
.container--countdown div {
  text-align: center;
}

.dot{
  font-size: 60px;
}
</style>